import { browserHistory } from 'react-router'

export const USER_LOGGED_OUT = 'USER_LOGGED_OUT'
export const CITY_LOGGED_OUT = 'CITY_LOGGED_OUT'
export const TOKEN_LOGGED_OUT = 'TOKEN_LOGGED_OUT'
export const PROPOSAL_LOGGED_OUT = 'PROPOSAL_LOGGED_OUT'
export const CLEAR_TRANSACTION = 'CLEAR_TRANSACTION'

function userLoggedOut() {
    return {
        type: USER_LOGGED_OUT,
        payload: ''
    }
}
function cityLoggedOut() {
    return {
        type: CITY_LOGGED_OUT,
        payload: ''
    }
}
function tokenLoggedOut() {
    return {
        type: TOKEN_LOGGED_OUT,
        payload: ''
    }
}
function proposalLoggedOut() {
    return {
        type: PROPOSAL_LOGGED_OUT,
        payload: ''
    }
}
function transactionLoggedOut() {
    return {
        type: CLEAR_TRANSACTION,
        payload: ''
    }
}

export function logoutUser() {
    return function(dispatch) {

        dispatch(userLoggedOut())
        dispatch(cityLoggedOut())
        dispatch(tokenLoggedOut())
        dispatch(proposalLoggedOut())
        dispatch(transactionLoggedOut())

        return browserHistory.push('/')
    }
}



// WEBPACK FOOTER //
// ./src/user/actions/LogoutAction.js